import { api, unwrap } from '@/core/http';
import type { ScheduleBody, VisitStatusCode } from '../domain/visit';

const visit = (visit_id: string) => ({ params: { path: { visit_id } } });

export interface ListVisitsParams {
  status?: VisitStatusCode;
  limit: number;
  offset: number;
}

/** As rotas do time de relacionamento — todas pedem `visitas.gerenciar`. */
export const visitsApi = {
  list: ({ status, limit, offset }: ListVisitsParams) =>
    unwrap(api.GET('/v1/visits', { params: { query: { status, limit, offset } } })),

  get: (visitId: string) => unwrap(api.GET('/v1/visits/{visit_id}', visit(visitId))),

  contacting: (visitId: string) => unwrap(api.POST('/v1/visits/{visit_id}/contacting', visit(visitId))),

  schedule: (visitId: string, body: ScheduleBody) =>
    unwrap(api.POST('/v1/visits/{visit_id}/schedule', { ...visit(visitId), body })),

  complete: (visitId: string) => unwrap(api.POST('/v1/visits/{visit_id}/complete', visit(visitId))),

  cancel: (visitId: string, reason: string) =>
    unwrap(api.POST('/v1/visits/{visit_id}/cancel', { ...visit(visitId), body: { reason } })),
};
